export default __webpack_public_path__ + "locales/sk/People.json?hash=01d525a9c6f60edb788481efb860d498";